import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React from 'react'
import { useTranslation } from 'react-i18next'

import coverEn from '@src/assets/images/resources-menu/training-catalog-en.webp'
import coverFr from '@src/assets/images/resources-menu/training-catalog-fr.webp'
import i18n from '@src/config/i18n'

import ArrowedButtonLink from './ArrowedButtonLink'
import GridLayout from './GridLayout'

export default function ExploreArticle() {
  const { t } = useTranslation('revamp')
  const breakpoints = useBreakpoint()

  return (
    <GridLayout className='bg-white rounded-lg px-3 md3:px-8 xl3:px-24 my-20 items-start'>
      <div className='pt-5 pb-20 xxs3:py-20'>
        {breakpoints.md ? (
          <h2 className='text-r-6xl leading-none'>
            <span className='font-bold'>{t('neverStopLearning.boldPart')}</span>
            <br />
            {t('neverStopLearning.regularPart')}
          </h2>
        ) : (
          <div className='flex flex-col xxs3:flex-row items-start xxs3:items-end overflow-visible'>
            <h2 className='mt-4 xxs3:mt-0 text-r-6xl leading-none'>
              <span className='font-bold'>{t('neverStopLearning.boldPart')}</span>
              <br />
              {t('neverStopLearning.regularPart')}
            </h2>
            <img
              className='order-first xxs3:order-last w-2/3 xxs3:w-1/3 h-auto block xxs3:absolute right-10 justify-self-center'
              src={coverFr}
              alt='Cover'
              style={{ maxWidth: '180px' }}
            />
          </div>
        )}
        <div className='my-10'>
          <h3
            className='font-bold leading-mid text-r-3xl mb-5'
            dangerouslySetInnerHTML={{
              __html: t('exploreActTransform'),
            }}
          ></h3>
          <p className='text-r-2xl leading-small'>{t('exploreText')}</p>
        </div>
        <div className='flex items-center md3:block'>
          <ArrowedButtonLink
            to={t('magazineUrl')}
            text={t('downloadExplore')}
            variant='outline-primary'
          />
        </div>
      </div>
      {breakpoints.md && (
        <div className='mx-auto pb-20'>
          <img
            className='justify-self-center w-4/5 h-auto -mt-20'
            src={i18n.language === 'fr' ? coverFr : coverEn}
            alt='Cover'
          />
        </div>
      )}
    </GridLayout>
  )
}
